import React, { useState } from 'react';
import { analyzeAndSanitize } from '../../utils/sanitizeHtml';

function TestIframePage() {
  const [htmlInput, setHtmlInput] = useState(`<iframe style="border: 0; width: 100%; height: 120px;" src="https://bandcamp.com/EmbeddedPlayer/album=1371653454/size=large/bgcol=ffffff/linkcol=0687f5/tracklist=false/artwork=small/transparent=true/" seamless><a href="https://andyaquarius.bandcamp.com/album/the-organs-of-matter-wheel">The Organs Of Matter Wheel by Ozbolt</a></iframe>`);
  const [sanitizedHtml, setSanitizedHtml] = useState('');
  const [report, setReport] = useState(null);

  const handleSanitize = () => {
    const result = analyzeAndSanitize(htmlInput);
    setSanitizedHtml(result.html);
    setReport(result.report);
    console.log('Sanitization result:', result);
  };

  return (
    <div style={{ padding: '20px', maxWidth: '1200px', margin: '0 auto' }}>
      <h1>Iframe Test Page</h1>
      
      <div style={{ marginBottom: '20px' }}>
        <h2>Input HTML:</h2>
        <textarea
          value={htmlInput}
          onChange={(e) => setHtmlInput(e.target.value)}
          style={{ width: '100%', height: '150px', fontFamily: 'monospace' }}
        />
        <button onClick={handleSanitize} style={{ marginTop: '10px', padding: '10px 20px' }}>
          Sanitize and Display
        </button>
      </div>

      {sanitizedHtml && (
        <>
          <div style={{ marginBottom: '20px' }}>
            <h2>Sanitized HTML (Raw):</h2>
            <pre style={{ background: '#f5f5f5', padding: '10px', overflow: 'auto' }}>
              {sanitizedHtml}
            </pre>
          </div>

          <div style={{ marginBottom: '20px' }}>
            <h2>Rendered Output:</h2>
            <div 
              style={{ border: '2px solid #ccc', padding: '20px', background: '#fff' }}
              dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
            />
          </div>

          {report && (
            <div style={{ marginBottom: '20px' }}>
              <h2>Sanitization Report:</h2>
              <pre style={{ background: '#f5f5f5', padding: '10px', overflow: 'auto' }}>
                {JSON.stringify(report, null, 2)}
              </pre>
            </div>
          )}
        </>
      )}

      <div style={{ marginTop: '40px', padding: '20px', background: '#f0f0f0' }}>
        <h3>Test Cases:</h3>
        <button 
          onClick={() => setHtmlInput(`<iframe style="border: 0; width: 100%; height: 120px;" src="https://bandcamp.com/EmbeddedPlayer/album=1371653454/size=large/bgcol=ffffff/linkcol=0687f5/tracklist=false/artwork=small/transparent=true/" seamless><a href="https://andyaquarius.bandcamp.com/album/the-organs-of-matter-wheel">The Organs Of Matter Wheel by Ozbolt</a></iframe>`)}
          style={{ margin: '5px' }}
        >
          Bandcamp Embed
        </button>
        <button 
          onClick={() => setHtmlInput(`<iframe width="560" height="315" src="https://www.youtube.com/embed/dQw4w9WgXcQ" frameborder="0" allowfullscreen></iframe>`)}
          style={{ margin: '5px' }}
        >
          YouTube Embed
        </button>
        <button 
          onClick={() => setHtmlInput(`<iframe src="https://open.spotify.com/embed/track/4PTG3Z6ehGkBFwjybzWkR8" width="300" height="380" frameborder="0" allowtransparency="true" allow="encrypted-media"></iframe>`)}
          style={{ margin: '5px' }}
        >
          Spotify Embed
        </button>
      </div>
    </div>
  );
}

export default TestIframePage;
